import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import getEventCounts from './getEventCounts';
import { getFirstDay } from '../../utils/dateTime';

export type EventDayType = {
  date: string,
  earnings: number,
  stockSplits: number,
  ipos: number,
  economicEvents: number,
  dateCaption?: string
}

export default function useEventCalendar(search = '', dateCaptionFormat = 'd MMM, EEE') {
  const [eventsList, setEventsList] = useState<EventDayType[]>([]);
  const [eventListLoading, setEventsListLoading] = useState(true);

  const [currentDate, setCurrentDate] = useState<Date>(new Date());
  const [fromDate, setFromDate] = useState<Date>(
    getFirstDay(new Date(currentDate)),
  );

  useEffect(() => {
    if (
      format(getFirstDay(currentDate), 'yyyy-MM-dd')
            !== format(fromDate, 'yyyy-MM-dd')
    ) {
      setFromDate(getFirstDay(currentDate));
    }
  }, [currentDate]);

  useEffect(() => {
    setEventsListLoading(true);
    getEventCounts({ fromDate, search }).then((result) => {
      const eventsListData: EventDayType[] = [];
      result.forEach((item) => {
        if (!eventsListData[item.index]) {
          eventsListData.push({
            date: '',
            earnings: 0,
            stockSplits: 0,
            ipos: 0,
            economicEvents: 0,
          });
        }
        eventsListData[item.index][item.type] = item.count || 0;
        if (!eventsListData[item.index].date) {
          eventsListData[item.index].dateCaption = format(
            item.date,
            dateCaptionFormat,
          );
          eventsListData[item.index].date = format(item.date, 'yyyy-MM-dd');
        }
      });
      setEventsList(eventsListData);
      setEventsListLoading(false);
    });
  }, [fromDate, search, dateCaptionFormat]);

  return {
    eventsList,
    eventListLoading,
    currentDate,
    setCurrentDate,
    fromDate,
    setFromDate,
  };
}
